import Request from "./constants/Request.api"
import Response from "./constants/Response.api"

const BASE_URL = process.env.REACT_APP_BASE_URL

const OK_RESPONSES = [200, 201, 202, 203, 204, 205, 206, 207, 208, 209]
class Api {
  async getRequest(req) {
    let headers = {}

    if (req.token !== null) {
      headers = {
        "Content-Type": "application/json",
        Authorization: req.data.token,
      }
    } else {
      headers = { "Content-Type": "application/json" }
    }

    const requestOptions = {
      method: "GET",
      headers: headers,
    }

    // console.log(req)

    try {
      const response = await fetch(BASE_URL + req.data.url).catch(error => {
        // console.log(error)
        return new Response({
          code: 500,
          message: "server error",
          status: false,
        })
      })

      const data = await response.json()

      if (OK_RESPONSES.includes(data.code)) {
        return new Response({ ...data, status: true })
      } else {
        return new Response({ ...data, message: data.error, status: false })
      }
    } catch (error) {
      // console.log(error)
      return new Response({ code: 500, message: "server error", status: false })
    }
  }

  async postRequest(req) {
    let headers = {}

    if (req.token !== null) {
      headers = {
        "Content-Type": "application/json",
        Authorization: req.data.token,
      }
    } else {
      headers = { "Content-Type": "application/json" }
    }

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(req.data),
    }

    // console.log(req)
    try {
      const response = await fetch(
        BASE_URL + req.data.url,
        requestOptions
      ).catch(error => {
        // console.log("error sending a post request", error)
        return new Response({
          code: 500,
          message: "server error",
          status: false,
        })
      })

      const data = await response.json()

      if (OK_RESPONSES.includes(data.code)) {
        return new Response({ ...data, status: true })
      } else {
        // console.log(data)
        return new Response({ ...data, message: data.error, status: false })
      }
    } catch (error) {
      // console.log(error)
      return new Response({ code: 500, message: "server error", status: false })
    }
  }

  async uploadRequest(req) {
    let headers = {}

    if (req.token !== null) {
      headers = {
        Accept: "application/x-www-form-urlencoded",
        Authorization: req.data.token,
      }
    } else {
      headers = { "Content-Type": "application/json" }
    }

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: req.data.formData,
    }

    try {
      const response = await fetch(
        BASE_URL + req.data.url,
        requestOptions
      ).catch(error => {
        // console.log(error)
        return new Response({
          code: 500,
          message: "server error",
          status: false,
        })
      })

      const data = await response.json()
      // console.log("api.js",data)
      
      if (OK_RESPONSES.includes(data.code)) {
        return new Response({ ...data, status: true })
      } else {
        // console.log(data)
        return new Response({ ...data, message: data.error, status: false })
      }
    } catch (error) {
      // console.log(error)
      return new Response({ code: 500, message: "server error", status: false })
    }
  }

  async downloadRequest(req) {
    let headers = {}

    if (req.token !== null) {
      headers = {
        "Content-Type": "application/json",
        Authorization: req.data.token,
      }
    } else {
      headers = { "Content-Type": "application/json" }
    }

    const requestOptions = {
      method: "GET",
      //headers: headers,
    }

    // console.log(req)

    try {
      const response = await fetch(BASE_URL + req.data.url).catch(error => {
        // console.log(error)
        return new Response({
          code: 500,
          message: "server error",
          status: false,
        })
      })
      // console.log(response)
      // const data = await response.json()

      // if (OK_RESPONSES.includes(data.code)) {
      //   return new Response({ ...data, status: true })
      // } else {
      //   return new Response({ ...data, message: data.error, status: false })
      // }
      return response
    } catch (error) {
      return new Response({ code: 500, message: "server error", status: false })
    }
  }
}

export default Api
